import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import type { AutoformattingProvider } from '@atlaskit/editor-common/provider-factory/autoformatting-provider';

import { createConfluenceAutoformattingProvider } from '@confluence/fabric-media-support/entry-points/AutoformattingProvider.ts';

type UseAutoformattingProviderProps = {
	contentId: string;
	spaceKey: string;
	source: string;
};

export function useAutoformattingProvider({
	contentId,
	spaceKey,
	source,
}: UseAutoformattingProviderProps): Promise<AutoformattingProvider> {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return useMemo<Promise<AutoformattingProvider>>(
		() =>
			Promise.resolve(
				createConfluenceAutoformattingProvider(spaceKey, contentId, createAnalyticsEvent, source),
			),
		[contentId, createAnalyticsEvent, spaceKey, source],
	);
}
